module.exports = __webpack_public_path__ + "static/media/iconoNotificacion.97541a16.png";